import React, { ReactNode, ReactElement, FC, useEffect } from 'react';
import * as Sentry from '@sentry/react';
import constants from '../constants';

const { ENV, VERSION, SENTRY_DSN, DEBUG } = constants;

let sentryStarted = false;

const initSentry = () => {
    if (sentryStarted || DEBUG || !SENTRY_DSN) return;
    Sentry.init({
        dsn: SENTRY_DSN,
        environment: ENV,
        release: VERSION || undefined,
        sendDefaultPii: true,
    });
    sentryStarted = true;
};

interface DebugWrapperProps {
    children: ReactNode;
}

const DebugWrapper: FC<DebugWrapperProps> = ({ children }) => {
    useEffect(() => {
        initSentry();
    }, []);

    if (DEBUG || !SENTRY_DSN) {
        return children as ReactElement;
    }

    return (
        <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
            {children}
        </Sentry.ErrorBoundary>
    );
};

export default DebugWrapper;
